import Head from 'next/head';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

type Props = {
    title: string;
};

const SupportMetaTagHead = ({ title }: Props) => {
    const {
        locale,
        query: { company, product },
    } = useRouter();

    const url = useMemo(
        () => `https://${company}.pimster.app/${product}/support`,
        [company, product]
    );

    const structuredData = useMemo(
        () => ({
            '@context': 'http://schema.org/',
            '@type': 'WebPage',
            name: title,
            url,
        }),
        [title, url]
    );

    return (
        <Head>
            {/* Generic */}
            <title>{title || 'Support'}</title>
            <meta name='robots' content='indexifembedded' />
            <meta name='title' content={title || 'Support Title'} />
            <meta name='description' content='Support Description' />

            {/* OpenGraph */}
            <meta property='og:title' content={title || 'Support'} />
            <meta property='og:type' content='video.other' />
            <meta property='og:url' content={url} />
            <meta property='locale' content={locale} />
            <meta property='og:description' content='' />

            {/* Twitter */}
            <meta property='twitter:card' content='summary_large_image' />
            <meta property='twitter:url' content={url} />
            <meta property='twitter:title' content={title || 'Support'} />
            <meta property='twitter:description' content='' />

            {/* Prevent zoon after input focus on Mozilla */}
            <meta
                name='viewport'
                content='width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1'
            />

            {/* Structured Data */}

            <script type='application/ld+json'>
                {JSON.stringify(structuredData)}
            </script>
        </Head>
    );
};

export default SupportMetaTagHead;
